/**
 * usePortfolio – portfolio data + history, backed by backend API.
 */
import { create } from 'zustand'
import {
  getPortfolioSnapshot,
  getPortfolioHistory,
  postOptimizePortfolio,
} from '@/lib/api'
import type { PortfolioSnapshot, HistoryPoint, OptimizeResult, UserProfile } from '@/lib/types'
import { DEFAULT_PROFILE } from './useAgents'

interface PortfolioState {
  snapshot: PortfolioSnapshot | null
  history: HistoryPoint[]
  optimization: OptimizeResult | null
  loading: boolean
  optimizing: boolean
  error: string | null
  // Actions
  fetchSnapshot: () => Promise<void>
  fetchHistory: (days?: number) => Promise<void>
  optimize: (profile?: UserProfile) => Promise<void>
}

export const usePortfolio = create<PortfolioState>()((set, get) => ({
  snapshot: null,
  history: [],
  optimization: null,
  loading: false,
  optimizing: false,
  error: null,

  fetchSnapshot: async () => {
    set({ loading: true, error: null })
    try {
      const snapshot = await getPortfolioSnapshot()
      set({ snapshot, loading: false })
    } catch (e) {
      set({ error: String(e), loading: false })
    }
  },

  fetchHistory: async (days = 30) => {
    try {
      const history = await getPortfolioHistory('unman_lai_001', days)
      set({ history })
    } catch (e) {
      console.error('History fetch failed', e)
    }
  },

  optimize: async (profile = DEFAULT_PROFILE) => {
    const { snapshot } = get()
    if (!snapshot) return
    set({ optimizing: true, error: null })
    try {
      const optimization = await postOptimizePortfolio(profile, snapshot)
      set({ optimization, optimizing: false })
    } catch (e) {
      set({ error: String(e), optimizing: false })
    }
  },
}))
